<ui-input-select-wrapper #selectWrapper [open]="open()">
    <ui-input-wrapper
        [label]="label()"
        [value]="selectedValue()?.label ?? value() ?? undefined"
        [focussed]="focussed()"
        [error]="error()"
        [errorMsg]="errorMsg()"
    >
        <input
            class="flex h-full w-full items-center px-16 text-black outline-none transition-all"
            [value]="selectedValue()?.label ?? value()"
            (input)="onInput($event)"
            (focus)="_onTouch?.(); focussed.set(true)"
            (blur)="focussed.set(false)"
            (keypress)="$event.keyCode === 13 ? onEnter() : null"
            type="text"
        />
    </ui-input-wrapper>

    <div class="flex w-full flex-col" dropdown>
        @for (option of autocompleteOptions(); let i = $index; track i) {
            <button
                class="flex items-center text-wrap px-16 py-12 text-left transition-colors hover:bg-grey-100"
                (click)="selectAutocomplete(option)"
            >
                {{ option.label }}
            </button>
        }
    </div>
</ui-input-select-wrapper>
